import { increaseOtrView } from 'APIs/HotAuctionApi';
import { useAppSelector } from 'app/hooks';
import { selectAuth } from 'features/auth/authSlice';
import { selectOtr } from 'features/auth/otrSlice';
import { OtrData } from 'interfaces/OtrData.interface';
import { useEffect, useRef, useState } from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { useLocation, useNavigate } from 'react-router-dom';

import Loader from 'components/atoms/loader';
import Video from './MobileOtrVideo';
import { Grid, IconButton } from '@mui/material';
import { NormalButton } from 'components/atoms/Button';

const Index = () => {
  const otrState = useAppSelector(selectOtr);
  const authState = useAppSelector(selectAuth);
  const location = useLocation();
  const [currentOtr, setCurrentOtr] = useState<OtrData>();
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [, setMousePos] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const toggleFade = (e: MouseEvent) => {
      setMousePos({
        x: e.clientX,
        y: e.clientY,
      });
    };
    document.addEventListener('mousemove', toggleFade);
    return () => {
      document.removeEventListener('mousemove', toggleFade);
    };
    //eslint-disable-next-line
  }, [authState.id]);

  useEffect(() => {
    if (otrState.otrs) {
      setCurrentIndex(Math.floor(Math.random() * (otrState.otrs.length - 1)));
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (otrState.otrs && otrState.otrs[currentIndex]) {
      setCurrentOtr(otrState.otrs[currentIndex]);
      window.history.replaceState(
        null,
        'Buku',
        `/explore/otr/${otrState.otrs[currentIndex].id}`
      );
      const addView = async () => {
        try {
          if (otrState.otrs)
            await increaseOtrView(otrState.otrs[currentIndex].id);
        } catch (error) {
          console.log(error);
        }
      };
      addView();
    }
    //eslint-disable-next-line
  }, [currentIndex, otrState]);

  useEffect(() => {
    const id = location.pathname.split('/')[3];
    if (otrState.otrs && id) {
      const index = otrState.otrs.findIndex(otr => otr.id === +id);
      setCurrentOtr(otrState.otrs[index]);
      setCurrentIndex(index);
    }
  }, [location.pathname, otrState.otrs]);

  const [autoScroll, setAutoScroll] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className="video__cont">
      {otrState.loading ? (
        <Loader />
      ) : (
        otrState.otrs &&
        otrState.otrs.map(nft => {
          return (
            currentOtr && (
              <Video
                setCurrentIndex={setCurrentIndex}
                currentIndex={currentIndex}
                data={currentOtr}
                key={currentOtr?.id}
                url={currentOtr?.src_url}
                autoScroll={autoScroll}
                setAutoScroll={setAutoScroll}
                otr={currentOtr}
              />
            )
          );
        })
      )}
      {otrState.loading ? (
        <Loader />
      ) : otrState.otrs ? (
        otrState.otrs.length === 0 ? (
          <>
            <Grid
              style={{
                width: '70%',
                display: 'flex',
                position: 'absolute',
                zIndex: '1000',
                margin: '20px 15%',
                justifyContent: 'space-around',
              }}
            >
              <IconButton
                sx={{
                  position: 'fixed',
                  top: 20,
                  left: 20,
                  zIndex: 99,
                  color: 'white',
                }}
                onClick={() => navigate('/')}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <NormalButton
                onClick={() => {
                  navigate(`/explore/nft`);
                }}
                sx={{
                  width: '110px',
                  height: '47px',
                }}
              >
                Explore NFT
              </NormalButton>
              <NormalButton
                onClick={() => {
                  navigate(`/explore/otr`);
                }}
                sx={{
                  width: '110px',
                  height: '47px',
                  backgroundColor: '#ccaf35',
                }}
              >
                Explore OTR
              </NormalButton>
            </Grid>
          </>
        ) : (
          otrState.otrs.map(nft => {
            return (
              currentOtr && (
                <Video
                  setCurrentIndex={setCurrentIndex}
                  currentIndex={currentIndex}
                  data={currentOtr}
                  key={currentOtr?.id}
                  url={currentOtr?.src_url}
                  autoScroll={autoScroll}
                  setAutoScroll={setAutoScroll}
                  otr={currentOtr}
                />
              )
            );
          })
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default Index;
